import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { ChartNoAxesGantt, Circle, CopyPlus, CornerLeftDown, CornerRightUp, Edit, EllipsisVertical, EyeOff, FolderKanban, GripVertical, MailCheck, MessageSquare, Minus, MoveLeft, Palette, Pencil, Plus, Square, Squircle, SwitchCamera, Trash2, TvMinimalPlay, Video, X, Youtube } from "lucide-react";
import ImageWithFallback from "../../../UI/ImageFallBack";
import LoadingButton from "../../../Loading/LoadingButton";
import Toggle from "../../../UI/Toggle";
import DropDownButtonUI from "./DropDownButtonUI";
import YoutubeVideoPlayerWebUI from "../../../UI/YoutubeVideoPlayerWebUI";
import ToggleSmall from "../../../UI/ToggleSmall";
import ToggleSmallUI from "../../../UI/ToggleSmallUI";
import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
import ColorPickerGradientDynamic from "../../../UI/ColorPicker/ColorPickerGradientDynamic";
import ColorPickerDynamicTwo from "../../../UI/ColorPicker/ColorPickerDynamicTwo";
import ContentCardUIButtonSettings from "./ContentCardUIButtonSettings";
import YoutubeDefaultPlayer from "../../../UI/YoutubeDefaultPlayer";
import VimeoVideoPlayerWebUI from "../../../UI/VimeoVideoPlayerWebUI";
import VimeoDefaultPlayer from "../../../UI/VimeoDefaultPlayer";
import UniversalVideoPlayer from "../../../UI/UniversalVideoPlayerWebUI";



const ContentCardUISettings = ({ cards, changeImages ,sendBackArray,currentContentIndex,dynamicId,setItemArr,setItemArrCurrent}) => {
       const dispatch = useDispatch();  
   const [isLoaded, setIsLoaded] = useState(false);
   const [settingType, setSettingType] = useState("allCards");
    const [hasError, setHasError] = useState(false);
   const [hideImage, setHideImage] = useState(false);
   const [hideTitle, setHideTitle] = useState(false);
   const [hideSubtitle, setHideSubTitle] = useState(false);
    const [hideVideo, setHideVideo] = useState(false);
    const [hideButtons, setHideButtons] = useState(false);
    const [playerTheme, setPlayerTheme] = useState("");
   const [resolution, setPxPercent] = useState('px');
   const [cornerType, setCornerType] = useState('square');
   const [playBtnColorSetType, setPlayBtnColorSetType] = useState('');
   const [playIconColorSetType, setPlayIconColorSetType] = useState('');
   const [buttonBGColorSetType, setButtonBGColorSetType] = useState('');
   const [buttonTextAndIconColorSetType, setButtonTextAndIconColorSetType] = useState('');
   
   const [palletPlayBtnBG, setPalletPlayBtnBG] = useState(false);
   const [palletPlayBtnBGGradient, setPalletPlayBtnBGGradient] = useState(false);
   const [palletPlayBtnBGHover, setPalletPlayBtnBGHover] = useState(false);
   const [palletPlayBtnBGHoverGradient, setPalletPlayBtnBGHoverGradient] = useState(false);

 
   const [palletPlayIconBG, setPalletPlayIconBG] = useState(false);
   const [palletPlayIconBGGradient, setPalletPlayIconBGGradient] = useState(false);
   const [palletPlayIconBGHover, setPalletPlayIconBGHover] = useState(false);
   const [palletPlayIconBGHoverGradient, setPalletPlayIconBGHoverGradient] = useState(false);


   
   const [palletButtonBGColor, setPalletButtonBGColor] = useState(false);
   const [palletButtonBGColorGradient, setPalletButtonBGColorGradient] = useState(false);
   const [palletButtonBGColorHover, setPalletButtonBGColorHover] = useState(false);
   const [palletButtonBGColorHoverGradient, setPalletButtonBGColorHoverGradient] = useState(false);
 const [palletButtonTextAndIconColor, setPalletButtonTextAndIconColor] = useState(false);
   const [palletButtonTextAndIconColorGradient, setPalletButtonTextAndIconColorGradient] = useState(false);
   const [palletButtonTextAndIconColorHover, setPalletButtonTextAndIconColorHover] = useState(false);
   const [palletButtonTextAndIconColorHoverGradient, setPalletButtonTextAndIconColorHoverGradient] = useState(false);
  const [startButtonEdit, setStartButtonEdit] = useState(false);
   
   const [buttonNumber ,setButtonNumber] =useState("button1")
    
const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }

      const [itemArr, setCardsArr] = useState(cards);
      const [buttonArr, setButtonsArr] = useState([]);
      const [buttonObject, setButtonObject] = useState({});
     
      const [itemNo, setItemNo] = useState(1);
      const [itemTitle, setItemTitle] = useState();
      const [itemSubTitle, setItemSubTitle] = useState();
    const [itemHideImage, setItemHideImage] = useState();
     
  const [loader , setLoader] =useState({status:false});
  const [editImage , setEditImage] =useState(false);
  const [cardObject , setCardObject] =useState({});
  
     const [openFullImg, setOpenFullImg] = useState(false);
         function generateTimestamp() {
              return Math.floor(Date.now() / 1000);
            }

useEffect(()=>{
  
},[])
  function getYouTubeThumbnail(input) {
    try {
      // Extract video token
      const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      let videoId;
  
      if (input.startsWith("<iframe")) {
        const srcMatch = input.match(/src="([^"]+)"/);
        if (!srcMatch) {
          throw new Error("No src attribute found in the iframe tag");
        }
        const srcUrl = srcMatch[1];
        const match = srcUrl.match(regex);
        videoId = match ? match[1] : null;
      } else {
        const match = input.match(regex);
        videoId = match ? match[1] : null;
      }
  
      if (!videoId) {
        throw new Error("No video token found");
      }
  
      // Return thumbnail URLs
      return {
        default: `https://img.youtube.com/vi/${videoId}/default.jpg`,
        highQuality: `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
        mediumQuality: `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`,
        standardDefinition: `https://img.youtube.com/vi/${videoId}/sddefault.jpg`,
        maxResolution: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
      };
    } catch (error) {
      console.error("Error extracting thumbnail:", error.message);
      return null;
    }
  }
    function getVimeoId(input) {
    try {
      if (!input) return null;
      const str = String(input).trim();
      // If it's an iframe tag, extract src
      if (str.startsWith('<iframe')) {
        const srcMatch = str.match(/src="([^"]+)"/);
        if (srcMatch) {
          const url = srcMatch[1];
          const idMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
          return idMatch ? idMatch[1] : null;
        }
      }
      // If it's a url
      const urlMatch = str.match(/vimeo\.com\/(?:video\/)?(\d+)/) || str.match(/^(\d+)$/);
      if (urlMatch) return urlMatch[1];
      // last resort: try to find digits
      const digits = str.match(/(\d{6,})/);
      return digits ? digits[1] : null;
    } catch (e) {
      return null;
    }
  }

 function getVimeoThumbnail(input) {
    const id = getVimeoId(input);
    if (!id) return null;
    return {
      small: `https://vumbnail.com/${id}.jpg`,
      medium: `https://vumbnail.com/${id}.jpg`,
      large: `https://vumbnail.com/${id}.jpg`,
    };
  }

      const setButtonUpdate = (id, buttonData,type) => {
        // const buttonItems = buttonArr?.map(item =>
        //   item?.id === buttonId ? type=="buttonText"?{ ...item, buttonText :buttonData }:
        //   type=="buttonTheme"?{ ...item, buttonTheme :buttonData }:item : item
        
        // );
        
      
        // setButtonsArr(buttonItems);
        
  setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                 item.id === id ?  type=="button1Text"?{ ...item, button1:{...item?.button1 ,buttonText:buttonData} }
                 : type=="button1Text"?{ ...item, button1:{...item?.button1 ,buttonText:buttonData} }
               : type=="button2Text"?{ ...item, button2:{...item?.button2 ,buttonText:buttonData} }
               : type=="button3Text"?{ ...item, button3:{...item?.button3 ,buttonText:buttonData} }
               : type=="button4Text"?{ ...item, button4:{...item?.button4 ,buttonText:buttonData} }  
               : type=="button5Text"?{ ...item, button5:{...item?.button5 ,buttonText:buttonData} }
                 : type=="button1ShowText"?{ ...item, button1:{...item?.button1 ,showText:buttonData} }
               : type=="button2ShowText"?{ ...item, button2:{...item?.button2 ,showText:buttonData} }
               : type=="button3ShowText"?{ ...item, button3:{...item?.button3 ,showText:buttonData} }
               : type=="button4ShowText"?{ ...item, button4:{...item?.button4 ,showText:buttonData} }  
               : type=="button5ShowText"?{ ...item, button5:{...item?.button5 ,showText:buttonData} }
                  : type=="button1ShowIcon"?{ ...item, button1:{...item?.button1 ,showIcon:buttonData} }
               : type=="button2ShowIcon"?{ ...item, button2:{...item?.button2 ,showIcon:buttonData} }
               : type=="button3ShowIcon"?{ ...item, button3:{...item?.button3 ,showIcon:buttonData} }
               : type=="button4ShowIcon"?{ ...item, button4:{...item?.button4 ,showIcon:buttonData} }  
               : type=="button5ShowIcon"?{ ...item, button5:{...item?.button5 ,showIcon:buttonData} }
                 :type=="button1Theme"?{ ...item, button1:{...item?.button1 ,buttonTheme:buttonData} }
                  :type=="button2Theme"?{ ...item, button2:{...item?.button2 ,buttonTheme:buttonData} }
                  :type=="button3Theme"?{ ...item, button3:{...item?.button3 ,buttonTheme:buttonData} }
                  :type=="button4Theme"?{ ...item, button4:{...item?.button4 ,buttonTheme:buttonData} }
                  :type=="button5Theme"?{ ...item, button5:{...item?.button5 ,buttonTheme:buttonData} }
               :type=="button1ButtonBGColorNormal"?{ ...item, button1:{...item?.button1 ,buttonBGColor:{...item?.button1?.buttonBGColor,normal:buttonData}} }
                  :type=="button2ButtonBGColorNormal"?{ ...item, button2:{...item?.button2 ,buttonBGColor:{...item?.button2?.buttonBGColor,normal:buttonData}} }
                  :type=="button3ButtonBGColorNormal"?{ ...item, button3:{...item?.button3 ,buttonBGColor:{...item?.button3?.buttonBGColor,normal:buttonData}} }
                  :type=="button4ButtonBGColorNormal"?{ ...item, button4:{...item?.button4 ,buttonBGColor:{...item?.button4?.buttonBGColor,normal:buttonData}} }
                  :type=="button5ButtonBGColorNormal"?{ ...item, button5:{...item?.button5 ,buttonBGColor:{...item?.button5?.buttonBGColor,normal:buttonData}} }
                :type=="button1ButtonBGColorHover"?{ ...item, button1:{...item?.button1 ,buttonBGColor:{...item?.button1?.buttonBGColor,hover:buttonData}} }
                  :type=="button2ButtonBGColorHover"?{ ...item, button2:{...item?.button2 ,buttonBGColor:{...item?.button2?.buttonBGColor,hover:buttonData}} }
                  :type=="button3ButtonBGColorHover"?{ ...item, button3:{...item?.button3 ,buttonBGColor:{...item?.button3?.buttonBGColor,hover:buttonData}} }
                  :type=="button4ButtonBGColorHover"?{ ...item, button4:{...item?.button4 ,buttonBGColor:{...item?.button4?.buttonBGColor,hover:buttonData}} }
                  :type=="button5ButtonBGColorHover"?{ ...item, button5:{...item?.button5 ,buttonBGColor:{...item?.button5?.buttonBGColor,hover:buttonData}} }
                
                
                :type=="button1ButtonTextAndIconColorNormal"?{ ...item, button1:{...item?.button1 ,buttonTextAndIconColor:{...item?.button1?.buttonTextAndIconColor,normal:buttonData}} }
                  :type=="button2ButtonTextAndIconColorNormal"?{ ...item, button2:{...item?.button2 ,buttonTextAndIconColor:{...item?.button2?.buttonTextAndIconColor,normal:buttonData}} }
                  :type=="button3ButtonTextAndIconColorNormal"?{ ...item, button3:{...item?.button3 ,buttonTextAndIconColor:{...item?.button3?.buttonTextAndIconColor,normal:buttonData}} }
                  :type=="button4ButtonTextAndIconColorNormal"?{ ...item, button4:{...item?.button4 ,buttonTextAndIconColor:{...item?.button4?.buttonTextAndIconColor,normal:buttonData}} }
                  :type=="button5ButtonTextAndIconColorNormal"?{ ...item, button5:{...item?.button5 ,buttonTextAndIconColor:{...item?.button5?.buttonTextAndIconColor,normal:buttonData}} }
                :type=="button1ButtonTextAndIconColorHover"?{ ...item, button1:{...item?.button1 ,buttonTextAndIconColor:{...item?.button1?.buttonTextAndIconColor,hover:buttonData}} }
                  :type=="button2ButtonTextAndIconColorHover"?{ ...item, button2:{...item?.button2 ,buttonTextAndIconColor:{...item?.button2?.buttonTextAndIconColor,hover:buttonData}} }
                  :type=="button3ButtonTextAndIconColorHover"?{ ...item, button3:{...item?.button3 ,buttonTextAndIconColor:{...item?.button3?.buttonTextAndIconColor,hover:buttonData}} }
                  :type=="button4ButtonTextAndIconColorHover"?{ ...item, button4:{...item?.button4 ,buttonTextAndIconColor:{...item?.button4?.buttonTextAndIconColor,hover:buttonData}} }
                  :type=="button5ButtonTextAndIconColorHover"?{ ...item, button5:{...item?.button5 ,buttonTextAndIconColor:{...item?.button5?.buttonTextAndIconColor,hover:buttonData}} }
                :type=="button1ClickAction"?{ ...item, button1:{...item?.button1 ,onClickAction:buttonData} }
                  :type=="button2ClickAction"?{ ...item, button2:{...item?.button2 ,onClickAction:buttonData} }
                  :type=="button3ClickAction"?{ ...item, button3:{...item?.button3 ,onClickAction:buttonData} }
                  :type=="button4ClickAction"?{ ...item, button4:{...item?.button4 ,onClickAction:buttonData} }
                  :type=="button5ClickAction"?{ ...item, button5:{...item?.button5 ,onClickAction:buttonData} }
          :type=="button1PopUpLeadFormEmail"?{ ...item, button1:{...item?.button1 ,popUpLeadForm:{...item?.button1?.popUpLeadForm,sendLeadInfoToEmail:{...item?.button1?.popUpLeadForm?.sendLeadInfoToEmail,email:buttonData}}} }
                  :type=="button2PopUpLeadFormEmail"?{ ...item, button2:{...item?.button2 ,popUpLeadForm:{...item?.button2?.popUpLeadForm,sendLeadInfoToEmail:{...item?.button2?.popUpLeadForm?.sendLeadInfoToEmail,email:buttonData}}} }
                  :type=="button3PopUpLeadFormEmail"?{ ...item, button3:{...item?.button3 ,popUpLeadForm:{...item?.button3?.popUpLeadForm,sendLeadInfoToEmail:{...item?.button3?.popUpLeadForm?.sendLeadInfoToEmail,email:buttonData}}} }
                  :type=="button4PopUpLeadFormEmail"?{ ...item, button4:{...item?.button4 ,popUpLeadForm:{...item?.button4?.popUpLeadForm,sendLeadInfoToEmail:{...item?.button4?.popUpLeadForm?.sendLeadInfoToEmail,email:buttonData}}} }
                  :type=="button5PopUpLeadFormEmail"?{ ...item, button5:{...item?.button5 ,popUpLeadForm:{...item?.button5?.popUpLeadForm,sendLeadInfoToEmail:{...item?.button5?.popUpLeadForm?.sendLeadInfoToEmail,email:buttonData}}} }
                :
                 item : item
              
              );
    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems; })





      };
         const flattenedButtonData = buttonArr!=[]?Object.values(buttonArr):'';

      const updateCardsSettings=(val,type)=>{

   
 setItemArr((prev) => {
  // these keys are used when duplicating items
    const updatedItems = prev.map(item => { if (item?.contents[currentContentIndex]?.myKey === dynamicId) {
     
       return { ...item,
      contents: item?.contents.map((content, index) =>
    index === currentContentIndex
      ? { ...content, itemCards:{...content?.itemCards,cards:val}
 }
      : content
  ),
    };
  }
  return item;});
          //  if(type==="layoutBG"){alert(layoutSettings?.layoutBG?.title)};
          setItemArrCurrent(updatedItems);return updatedItems;; });
      }
  
            const removeItem = (id) => {
              const filteredItems = itemArr.filter(item => item.id !== id);
              setCardsArr(filteredItems);
            //   sendBackData(filteredItems)
            };
//             const updateItemTitle = (id, title) => {
              
//               setCardsArr((prev) => {
//     // Remove the item by filtering
//     const updatedItems = prev.map(item =>
//                 item.id === id ? { ...item, title :title } : item
              
//               );

//     // Optional: re-number items
//     const reorderedItems = updatedItems.map((item, index) => ({
//       ...item
//     }));
    
//      sendBackArray(reorderedItems)
// updateCardsSettings(reorderedItems)
     
//     return reorderedItems;
//   });
            
//             };  
              


const updateHideImage = (id, status) => {
               
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, hideImage :status } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
    
     sendBackArray(reorderedItems)
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            }; 
            
  

const updateHideTitle = (id, status) => {
               
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, hideTitle :status } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
    
     sendBackArray(reorderedItems)
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            }; 


const updateHideSubTitle = (id, status) => {
               
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, hideSubtitle :status } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
    
     sendBackArray(reorderedItems)
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            }; 
            
    const updateHideVideo = (id, status) => {
               
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, hideVideo :status } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
    
     sendBackArray(reorderedItems)
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            }; 
            
  const updateHideButtons = (id, status) => {
               
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, hideButtons :status } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
    
     sendBackArray(reorderedItems)
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            }; 
              
            const updatePlayerTheme = (id, playerTheme) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, video:{...item?.video ,playerTheme:playerTheme} } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
            

                const updateSourceType = (id, sourceType) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, video:{...item?.video ,sourceType:sourceType} } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
               const updateYoutubeLink = (id, youtubeLink) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, video:{...item?.video ,youtube:{...item?.video?.youtube,src:youtubeLink}} } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
             const updateVimeoLink = (id, vimeoLink) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, video:{...item?.video ,vimeo:{...item?.video?.vimeo,src:vimeoLink}} } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
            
  const updateMp4URL = (id, mp4URLLink) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, video:{...item?.video ,mp4URL:{...item?.video?.mp4URL,src:mp4URLLink}} } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
            const updateShowDefaultThumbnailYoutube = (id, status) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, video:{...item?.video ,youtube:{...item?.video?.youtube,showDefaultThumbnail:status}} } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };

                 const updateShowDefaultThumbnailVimeo = (id, status) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, video:{...item?.video ,vimeo:{...item?.video?.vimeo,showDefaultThumbnail:status}} } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
               const updateUseDefaultPlayerYoutube = (id, status) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, video:{...item?.video ,youtube:{...item?.video?.youtube,useDefaultPlayer:status}} } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
   const updatePlayButtonBorderRadius = (id, playButtonBorderRadius) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, video:{...item?.video ,videoPlayButton:{...item?.video?.videoPlayButton,playButtonBorderRadius:playButtonBorderRadius}} } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
  const updatePlayButtonBGNormal = (id, playButtonBGNormal) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
             item.id === id ? { ...item, video:{...item?.video ,videoPlayButton:{...item?.video?.videoPlayButton,playButtonColor:{...item?.video?.videoPlayButton?.playButtonColor,normal:playButtonBGNormal}}} } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };


            const updatePlayButtonBGHover = (id, playButtonBGHover) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
             item.id === id ? { ...item, video:{...item?.video ,videoPlayButton:{...item?.video?.videoPlayButton,playButtonColor:{...item?.video?.videoPlayButton?.playButtonColor,hover:playButtonBGHover}}} } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
 const updatePlayIconBGNormal = (id, playIconBGNormal) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
              item.id === id ? { ...item, video:{...item?.video ,videoPlayButton:{...item?.video?.videoPlayButton,playIconColor:{...item?.video?.videoPlayButton?.playIconColor,normal:playIconBGNormal}}} } : item
             
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };

        const updatePlayIconBGHover = (id, playIconBGHover) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
              item.id === id ? { ...item, video:{...item?.video ,videoPlayButton:{...item?.video?.videoPlayButton,playIconColor:{...item?.video?.videoPlayButton?.playIconColor,hover:playIconBGHover}}} } : item
             
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };

         const updateOnClickAction = (id, onClickAction) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
              item.id === id ? { ...item, video:{...item?.video ,videoPlayButton:{...item?.video?.videoPlayButton,onClickAction:onClickAction}} } : item
             
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            }; 
            
            
            const updateLeadFormDelay = (id, delayValue) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
              item.id === id ? { ...item, video:{...item?.video ,videoPlayButton:{...item?.video?.videoPlayButton,popUpLeadForm:{...item?.video?.videoPlayButton?.popUpLeadForm,delay:delayValue}}} } : item
             
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
  const updateSendLeadInfoEmailID = (id, EmailID) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
              item.id === id ? { ...item, video:{...item?.video ,videoPlayButton:{...item?.video?.videoPlayButton,popUpLeadForm:{...item?.video?.videoPlayButton?.popUpLeadForm,sendLeadInfoToEmail:{...item?.video?.videoPlayButton?.popUpLeadForm?.sendLeadInfoToEmail,email:EmailID}}}} } : item
             
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
  const updateShowNameInLeadForm = (id, status) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
              item.id === id ? { ...item, video:{...item?.video ,videoPlayButton:{...item?.video?.videoPlayButton,popUpLeadForm:{...item?.video?.videoPlayButton?.popUpLeadForm,showFields:{...item?.video?.videoPlayButton?.popUpLeadForm?.showFields,name:status}}}} } : item
             
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            }; 
            
            
            const updateShowEmailInLeadForm = (id,status) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
              item.id === id ? { ...item, video:{...item?.video ,videoPlayButton:{...item?.video?.videoPlayButton,popUpLeadForm:{...item?.video?.videoPlayButton?.popUpLeadForm,showFields:{...item?.video?.videoPlayButton?.popUpLeadForm?.showFields,email:status}}}} } : item
             
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };  
            
            const updateShowMobileNoInLeadForm= (id, status) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
              item.id === id ? { ...item, video:{...item?.video ,videoPlayButton:{...item?.video?.videoPlayButton,popUpLeadForm:{...item?.video?.videoPlayButton?.popUpLeadForm,showFields:{...item?.video?.videoPlayButton?.popUpLeadForm?.showFields,mobile:status}}}} } : item
             
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };

               const updateShowCityInLeadForm= (id, status) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
              item.id === id ? { ...item, video:{...item?.video ,videoPlayButton:{...item?.video?.videoPlayButton,popUpLeadForm:{...item?.video?.videoPlayButton?.popUpLeadForm,showFields:{...item?.video?.videoPlayButton?.popUpLeadForm?.showFields,city:status}}}} } : item
             
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
  const updateShowOnlyPlayButton= (id, status) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
              item.id === id ? { ...item, video:{...item?.video ,videoPlayButton:{...item?.video?.videoPlayButton,popUpVideo:{...item?.video?.videoPlayButton?.popUpVideo,showOnlyPlayButton:status}}} } : item
             
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };

            const updateHideVideoThumbnail = (id, status) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, video:{...item?.video ,videoThumbnail:{...item?.video?.videoThumbnail,hideThumbnail:status}} } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
          
                 const updateUseDefaultPlayerVimeo = (id, status) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, video:{...item?.video ,vimeo:{...item?.video?.vimeo,useDefaultPlayer:status}} } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));
     
     sendBackArray(reorderedItems);
    
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
          
            
            const updateItemTitle = (id, title) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, title :title } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));

     sendBackArray(reorderedItems)
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
            const updateItemSubTitle = (id, subtitle) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, subtitle :subtitle } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));

     sendBackArray(reorderedItems)
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
              const updateItemHideImage = (id, hideImage) => {
              
              setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.map(item =>
                item.id === id ? { ...item, hideImage :hideImage } : item
              
              );

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item
    }));

     sendBackArray(reorderedItems)
     updateCardsSettings(reorderedItems)
    return reorderedItems;
  });
            
            };
           
        
          const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
      const [draggedIndex, setDraggedIndex] = useState('');
      const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone
      
      const handleDragStart = (e, index) => {
        
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData("dragIndex", index);
        
      };
      
      const handleDrop = (e, dropIndex) => {
        const dragIndex = e.dataTransfer.getData("dragIndex");
        if (dragIndex === dropIndex) return;
      
        const updatedItems = [...itemArr];
        const [draggedItem] = updatedItems.splice(dragIndex, 1);
        updatedItems.splice(dropIndex, 0, draggedItem);
      
        const reorderedItems = updatedItems.map((item, index) => ({
          ...item,
          id: item.id,
        }));
        setCardsArr(reorderedItems);
        sendBackArray(reorderedItems)
        updateCardsSettings(reorderedItems)
        setDraggedIndex('');
        setHoveredDropZone(null); // Reset hovered drop zone
      };
      
      const handleDragOver = (e, index) => {
        e.preventDefault();
         // Set the hovered drop zone
      };
      
      const handleDragEnd = () => {
        setDraggedIndex('');
        setHoveredDropZone(null); // Clear hovered drop zone
      };
        const duplicateItem = (obj) => {
  
  setCardsArr((prev) => {
    const updatedItems = [...prev];
    const index = updatedItems.findIndex(item => item.id === obj?.id);

    if (index !== -1) {
      const originalItem = updatedItems[index];
      const duplicatedItem = {
        ...originalItem,
        id: Date.now(), // generate new unique ID
        myKey: originalItem.id + generateTimestamp(), // or use a better unique label
      };
  // console.log(originalItem)
      // Insert the duplicated item right after the original
      updatedItems.splice(index + 1, 0, duplicatedItem);

      const reorderedItems = updatedItems.map((item, idx) => ({
        ...item,
        no: idx + 1, // optional: re-number
      }));

    

    
    // this code is for reloading status for settings component
   updateCardsSettings(reorderedItems)
    sendBackArray(reorderedItems)
      return reorderedItems;
    }
    return prev;
  });
}; 
const deleteItem = (obj) => {
  setCardsArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.filter(item => item.id !== obj?.id);

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item,
      no: index + 1,
    }));
updateCardsSettings(reorderedItems)
     sendBackArray(reorderedItems)
    return reorderedItems;
  });
};
        
  return ( 

    <div style={{ padding:"10px",position:"relative"}}>
  
        { settingType=="allCards"?
        <div style={{fontSize:"12px",fontWeight:"500",padding:"10px",paddingTop:"0px",textAlign:"left"}}>
             <div style={{fontSize:"18px",fontWeight:"bold",padding:"10px",paddingTop:"15px",display:"flex",justifyContent:"left"}}>Cards</div> 
Add new item Card( Image , Buttons , Text , Videos)  to your  Layout and order them. Set the style for all Cards in the Design tab.</div>:""}
      {itemArr?.map((item,index) => (<div>
       { settingType=="allCards"?<div>
        
         <div
          className="drop-zone"
          onDragOver={(e) => {
            handleDragOver(e, index) // index+1 for add  below item
          }}
          onDrop={(e) =>{ handleDrop(e, index);setSelectedItemIndex(null);setHoveredDropZone(null);}}
        
          style={{
            height: hoveredDropZone === index ?'50px':"0px",position:hoveredDropZone === index ?'relative':"",left:"10px",right:"0px",
            backgroundColor: hoveredDropZone === index ? 'rgba(144, 202, 249,0.1) ' : 'transparent', // Change color on hover
            border: hoveredDropZone === index ? '2px dashed rgba(144, 202, 249,1) ' : 'transparent', // Change color on hover
            transition: 'background-color  0.3s ease',width:"95%",
            borderRadius: '10px',marginBottom:hoveredDropZone === index ?"20px":"0px",display:"flex",justifyContent:"center",
           visibility:hoveredDropZone === index ?"visible":"hidden",fontSize:"14px"
          }}
        >
            <div style={{paddingTop:"15px",}}>Drop Item Here</div></div>
        <div className="imageItemHover" key={item.id} style={{  opacity: selectedItemIndex!==index ?'1':"0.3", position: "relative",display: "flex", gap: "5px",justifyContent:"space-between"}}
        
        draggable  
onDragOver={(e) => { if(selectedItemIndex!==index){
  setHoveredDropZone(index);
    handleDragOver(e, index)
  }
  }}
  onDrop={(e) => {setSelectedItemIndex(null);setHoveredDropZone(null);}}

             onDragStart={(e) =>{
               handleDragStart(e, index);
              setDraggedIndex(item.id);setSelectedItemIndex(index);
             }}
            
              // onDragEnd={handleDragEnd}
onDragEnd={(e) =>{setSelectedItemIndex(null);setHoveredDropZone(null);}}
        
        
        ><div style={{  display: "flex", gap: "5px",justifyContent:"left"}}><div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{marginTop:"18px",height:"30px",cursor:"move",
        // opacity:selectedItemIndex!==index ?'':"0", 
      borderRadius:"50%",position:"relative",zIndex:"99999",
        alignContent:"center",textAlign:"center",padding:"5px"}}>
          <GripVertical color="rgba(144, 202, 249,1)" size={22} />
          </div>  <div  style={{ position:"relative"
            // opacity:selectedItemIndex!==index ?'':"0"
            }}>
             <ImageWithFallback src={item.image} widthOuter={"80px"} fireOpenEdit ={()=>{setCardObject(item);setEditImage(true);setItemTitle(item?.title);setItemSubTitle(item?.subtitle)}} iconSize={28} setOpenFullImg={()=>{}}/> 
       <div style={{position:"absolute",top:"20px",left:"15px",}}>
        {item?.hideImage?<EyeOff size={35} style={{background:"rgba(44, 42, 42, 0.71)",width:"40px",height:"40px",borderRadius:"50%"}} color={"rgba(236, 228, 228, 1)"}/>:""} </div>  </div>
         
          <div style={{position: "relative",marginTop:"18px",
            // opacity:selectedItemIndex!==index ?'':"0"
            }}>
             <div  className="ButtonWithEllipsis" style={{
             width: `190px`, fontSize:`18px`,fontWeight:"600",textAlign: "left" ,
            
      }}>{item?.hideTitle?<EyeOff size={15} color={"rgba(249, 144, 144, 1)"}/>:""}{item?.title}</div>
       <div  className="ButtonWithEllipsis" style={{
             width: `190px`, fontSize:`12px`,fontWeight:"500",textAlign: "left" ,
            
      }}>{item?.hideSubtitle?<EyeOff size={15} color={"rgba(249, 144, 144, 1)"}/>:""}{item?.subtitle}</div>
              </div> </div>
              <div  className="hoverItemImages" onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>{
  }} style={{
    // opacity:selectedItemIndex!==index ?'':"0",
    border:"3px solid rgba(144, 202, 249,1) ",width:"20px",height:"20px",borderRadius:"50%",marginLeft:"0px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer",marginTop:"18px"}} color="rgba(144, 202, 249,1)" size={13}>
           <EllipsisVertical size={22}  color="rgba(144, 202, 249,1)"/>
           
           
           <div className="showImagesSettings" style={{ border:"3px solid rgba(144, 202, 249,1) ",borderRadius:"20px",paddingTop:"25px"}}>
            <div style={{position:"absolute",top:"-40px",left:"35px"}}><ImageWithFallback src={item.image} widthOuter={"70px"} fireOpenEdit ={()=>{setCardObject(item);setEditImage(true);setItemTitle(item?.title);setItemSubTitle(item?.subtitle)}}  iconSize={28} setOpenFullImg={()=>{}}/></div> 
           <div className=" showImagesSettingsItem"
     onClick={()=>{ setCardObject(item);setSettingType("editCard");setEditImage(true);setItemNo(index+1);
        setHideImage(item?.hideImage);;setHideTitle(item?.hideTitle);;setHideSubTitle(item?.hideSubtitle);
        ;setHideVideo(item?.hideVideo);;setHideButtons(item?.hideButtons);
        
       
        setItemTitle(item?.title);setItemSubTitle(item?.subtitle)}}
      > 
      <div className="ElementSettingsItem"
    
      ><Edit size={18}  color="#444" />
    </div><div className="" style={{ fontSize:`13px`,fontWeight:"600",paddingTop:"5px"}}
      
      >Edit Card</div>
    </div>      <div className=" showImagesSettingsItem"
      onClick={()=>{duplicateItem(item)}}
      > 
      <div className="ElementSettingsItem"
      
      ><CopyPlus size={18}  color="#444" />
    </div><div className="" style={{ fontSize:`13px`,fontWeight:"600",paddingTop:"5px"}}
      
      >Duplicate</div>
    </div>  <div className=" showImagesSettingsItem"
      onClick={()=>{deleteItem(item) }}
      > 
      <div className="ElementSettingsItem"
   
      ><Trash2 size={18}  color="#444" />
    </div><div className="" style={{ fontSize:`13px`,fontWeight:"600",paddingTop:"5px"}}
      
      >Delete</div>
    </div>
    </div></div>
        </div>

</div>:""}
      
       

        </div>

      ))}
       {settingType=="editCard"&&editImage?
        <div>
            
            <div style={{  display: "flex", gap: "5px",justifyContent:"left"}}>
             
        {/* <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:99999,cursor:"pointer",}} onClick={()=>{setEditImage(false);setCardObject({})}} className="appDesignPopUpOpacity"> </div> */}
        <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{position:"relative",cursor:"pointer",background:"#fff",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.1501)",width:"40px",height:"40px",left:"0px",top:"2px",margin:"5px",display:"flex",justifyContent:"center",alignItems:"center"}} onClick={()=>{setEditImage(false);setSettingType("allCards");setCardObject({})}} >
                <MoveLeft size={20} color={"#555"}  />
             </div>

        <h2 align="center" style={{marginTop:"13px"}} > Edit <span className="coloredTextV1" >Card  {itemNo}</span> </h2>
      </div>
 
<div className="bookmarkListScroll" style={{overflowY:"auto",height:"80%",overflowX:"hidden",paddingBottom:"60px"}}>
<div style={{display:"flex",justifyContent:"space-between",margin:"0px",marginBottom:"15px"}} >
    <div style={{border:"5px solid rgba(144, 202, 249,0.4) " ,width:"165px",borderRadius:"15px"}}>
   <div  style={{marginLeft:"10px"}}>
    <ImageWithFallback src={cardObject?.image} widthOuter={"140px"} fireOpenEdit ={()=>{}}  iconSize={44}  setOpenFullImg={()=>{setOpenFullImg(true)}}/>
         </div> <div  style={{display:"flex",justifyContent:"left",margin:"0px"}}><div ><h5 style={{width:"65px"}}>Hide Image  </h5></div>
                                    <Toggle state={hideImage} toggleState={(state)=>{ setHideImage(state);
                                     updateHideImage(cardObject?.id, state);}} />
                                       </div>  
         </div>
         <div style={{border:"5px solid rgba(144, 202, 249,0.4) " ,width:"165px",borderRadius:"15px"}}>
    <div  style={{marginLeft:"10px",position:"relative"}}>
         <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
     onClick={()=>{setSettingType("editVideo");setPlayerTheme(cardObject?.video?.playerTheme)}}
     style={{position:"absolute",border:"3px solid rgba(144, 202, 249,1) ",zIndex:"999999",cursor:"pointer",background:"#fff",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.1501)",width:"30px",height:"30px",right:"5px",top:"5px",margin:"0px",display:"flex",justifyContent:"center",alignItems:"center"}} >
                <Pencil size={20}  color={"#555"}  />
             </div>
      <TvMinimalPlay style={{marginTop:"40px"}} size={80} strokeWidth={1} color={"#555"}  />
        </div>  <div  style={{display:"flex",justifyContent:"left",marginTop:"0px"}}><div ><h5 style={{width:"65px"}}>Hide Video  </h5></div>
                                    <Toggle state={hideVideo} toggleState={(state)=>{ setHideVideo(state);
                                     updateHideVideo(cardObject?.id, state);}} />
                                       </div>  
         </div>
         
         </div>
{/* hide : <Toggle state={itemHideImage} toggleState={(state)=>{setItemHideImage(state) ;updateItemHideImage(cardObject?.id, state);}} /> */}
<div  className="ikcraft_login-input-card"style={{margin:"0px",padding:"0px"}}>
   <div style={{display:"flex",justifyContent:"space-between",margin:"0px",}} > <h3 style={{textAlign:"left"}} >Edit Title</h3> 
   <div className="gridForFiftyFixed"style={{display:"flex",justifyContent:"space-between",margin:"0px",}}><div><h4>Hide Title  </h4></div>
                                    <Toggle state={hideTitle} toggleState={(state)=>{ setHideTitle(state);
                                     updateHideTitle(cardObject?.id, state);}} />
                                       </div>  </div>
 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"20px",padding:"10px"}} placeholder={`Add Quiz Name`} type="text"
  rows={1} name="courseTitle" value={itemTitle} onChange={(e)=>{setItemTitle(e.target.value);updateItemTitle(cardObject?.id, e.target.value);}} />
 </div>
<div  className="ikcraft_login-input-card"style={{margin:"0px",padding:"0px"}}>
 <div style={{display:"flex",justifyContent:"space-between",margin:"0px",}} >  
     <h3 style={{textAlign:"left"}} >Edit Subtitle</h3> <div className="gridForFiftyFixed"style={{display:"flex",justifyContent:"space-between",margin:"0px",}}><div><h4>Hide  Subtitle  </h4></div>
                                    <Toggle state={hideSubtitle} toggleState={(state)=>{ setHideSubTitle(state);
                                     updateHideSubTitle(cardObject?.id, state);}} />
                                       </div>  </div>
 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"20px",padding:"10px"}} placeholder={`Add Quiz Name`} type="text"
  rows={3} name="courseTitle"  value={itemSubTitle} onChange={(e)=>{setItemSubTitle(e.target.value); updateItemSubTitle(cardObject?.id, e.target.value);}} />
 </div>

 <div  style={{display:"flex",justifyContent:"space-between",margin:"0px"}}><div ><h3 style={{textAlign:"left"}} >Edit Buttons</h3></div><h5 >Hide Buttons  </h5>
                                    <Toggle state={hideButtons} toggleState={(state)=>{ setHideButtons(state);
                                     updateHideButtons(cardObject?.id, state);}} />
                                       </div> 
<div style={{display: "flex",
justifyContent:"left"}}>
       
          <div     onClick={()=>{ setStartButtonEdit(false) ;setButtonNumber("button1");setSettingType("editButton");}}  style={{width:"130px",borderRadius:"10px",margin:"10px",fontSize:"14px",padding:"7px 10px"
            ,background:"#f1f1f1"}}>Btn 1</div>
           <div  onClick={()=>{ setStartButtonEdit(false) ;setButtonNumber("button2");setSettingType("editButton");}}  style={{width:"130px",borderRadius:"10px",margin:"10px",fontSize:"14px",padding:"7px 10px"
            ,background:"#f1f1f1"}}>Btn 2</div>
           <div  onClick={()=>{ setStartButtonEdit(false) ;setButtonNumber("button3");setSettingType("editButton");;}} style={{width:"130px",borderRadius:"10px",margin:"10px",fontSize:"14px",padding:"7px 10px"
            ,background:"#f1f1f1"}}>Btn 3</div>
           <div  onClick={()=>{ setStartButtonEdit(false) ;setButtonNumber("button4");setSettingType("editButton"); ;}} style={{width:"130px",borderRadius:"10px",margin:"10px",fontSize:"14px",padding:"7px 10px"
            ,background:"#f1f1f1"}}>Btn 4</div>
           <div  onClick={()=>{ setStartButtonEdit(false) ;setButtonNumber("button5");setSettingType("editButton");;}} style={{width:"130px",borderRadius:"10px",margin:"10px",fontSize:"14px",padding:"7px 10px"
            ,background:"#f1f1f1"}}>Btn 5</div>
           
          
          </div>


</div>



{/* <div align="center" className="" style={{position:"absolute",background:"#fff",height:"60px",left:"0px",right:"0px",bottom:"0px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   zIndex:"99",
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}  style={{position:"relative",background:"rgba(42, 43, 44, 1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"45px"}} 
  onMouseLeave={handleMouseLeave} onClick={()=>{setEditImage(false);setSettingType("allCards");setCardObject({})}}   className=" CoursesPreviewTopBtn"  type="submit"
 > Back </button>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{updateItemTitle(cardObject?.id, itemTitle);
    updateItemSubTitle(cardObject?.id, itemSubTitle);}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"45px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Update"} </button>
</div> */}
</div>:""}
{openFullImg?<div>
            <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:9999999,cursor:"pointer",background:"#000000"}} onClick={()=>{setOpenFullImg(false);}} className="appDesignPopUpOpacity"> 
   <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",right:"10px",margin:"10px",position:"absolute",
      background:"#958FDA",zIndex:99999999}} onClick={()=>{setOpenFullImg(false)}}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
 <div className="AreYouSurePopUpTwo " style={{overflowY:"auto",height:"99%",overflowX:"hidden"}}>
 
      
      <img
        src={cardObject?.image}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
        style={{
          borderRadius: "10px",
          position: "relative",
         
          width: "100%",zIndex:999999,
          
          
          marginTop: "0px",border:"3px solid rgba(144, 202, 249,1)",
        //   display: isLoaded && !hasError ? "block" : "none",
        }}
      /></div></div>
      
      
      </div>:""} 

{settingType=="editVideo"&&editImage?
        <div>
            
            <div style={{  display: "flex", gap: "5px",justifyContent:"left"}}>
             
        {/* <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:99999,cursor:"pointer",}} onClick={()=>{setEditImage(false);setCardObject({})}} className="appDesignPopUpOpacity"> </div> */}
        <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{position:"relative",cursor:"pointer",background:"#fff",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.1501)",
     width:"40px",height:"40px",left:"0px",top:"2px",margin:"5px",display:"flex",justifyContent:"center",alignItems:"center"}} onClick={()=>{setSettingType("editCard");}} >
                <MoveLeft size={20} color={"#555"}  />
             </div>

        <h2 align="center" style={{marginTop:"13px"}} > Edit Video In <span className="coloredTextV1" >Card  {itemNo}</span> </h2>
      </div>
 
<div className="bookmarkListScroll" style={{paddingBottom:"60px"}}>
<div style={{display:"flex",justifyContent:"space-around",margin:"0px",marginBottom:"15px"}} >
    <div style={{border:"5px solid rgba(144, 202, 249,0.4) " ,width:"330px",borderRadius:"15px",overflow:"hidden"}}>
   <div  style={{marginLeft:"0px",height:"250px",}}>

     {itemArr[itemNo-1]?.video?.sourceType=="youtube"?
          !itemArr[itemNo-1]?.video?.youtube?.useDefaultPlayer?<YoutubeVideoPlayerWebUI  videoSettings={itemArr[itemNo-1]?.video} videoId={itemArr[itemNo-1]?.video?.youtube?.src} minHeight={250} maxHeight={250}/>
           :<YoutubeDefaultPlayer videoSettings={itemArr[itemNo-1]?.video}   videoId={itemArr[itemNo-1]?.video?.youtube?.src} minHeight={250} maxHeight={250}/>
           :itemArr[itemNo-1]?.video?.sourceType=="vimeo"?
          !itemArr[itemNo-1]?.video?.vimeo?.useDefaultPlayer?<VimeoVideoPlayerWebUI  videoSettings={itemArr[itemNo-1]?.video} videoId={itemArr[itemNo-1]?.video?.vimeo?.src} minHeight={250} maxHeight={250}/>
           :<VimeoDefaultPlayer videoSettings={itemArr[itemNo-1]?.video}   videoId={itemArr[itemNo-1]?.video?.vimeo?.src} minHeight={250} maxHeight={250}/>
           :itemArr[itemNo-1]?.video?.sourceType=="mp4URL"?
          !itemArr[itemNo-1]?.video?.mp4URL?.useDefaultPlayer?<UniversalVideoPlayer  videoSettings={itemArr[itemNo-1]?.video} videoUrl={itemArr[itemNo-1]?.video?.mp4URL?.src} minHeight={250} maxHeight={250}/>
           :
           ""  :""}
         </div> <div  style={{display:"flex",justifyContent:"left",margin:"0px"}}><div ><h5 style={{width:"65px"}}>Hide Video  </h5></div>
                                    <Toggle state={hideVideo} toggleState={(state)=>{ setHideVideo(state);
                                     updateHideVideo(cardObject?.id, state);}} />
                                       </div>  
         </div> </div>
          {/* <div style={{background:"#ffffff",borderRadius:"15px",marginLeft:"3px",marginRight:"3px",marginTop:"-5px",padding:"10px",}}>
          <div style={{display:"flex",justifyContent:"space-between",position:"relative"}}><h4>Player Theme </h4>
            
            <DropDownButtonUI activeCard={""} icon={3} title={cards[itemNo-1]?.video?.playerTheme} 
                 onClickSendObject={(value)=>{  
                                    if(value){  updatePlayerTheme(cardObject?.id, value);}}}
                  hasDropDown={true} dropDownObject={[{title:"iClassic",value:"Classic"},{title:"iModern",value:"Modern"},{title:"iArtistic",value:"Artistic"},
               
                                                                                    ]} />  </div> </div> */}
             <div style={{background:"#ffffff",borderRadius:"15px",marginLeft:"3px",marginRight:"3px",marginTop:"-15px",padding:"10px",}}>
          <div style={{display:"flex",justifyContent:"space-between",position:"relative"}}><h4>Source Type </h4>
            {/* 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) */}
            <DropDownButtonUI activeCard={""} icon={4} title={cards[itemNo-1]?.video?.sourceType} 
                 onClickSendObject={(value)=>{  
                                    if(value){  updateSourceType(cardObject?.id, value);}}}
                  hasDropDown={true} dropDownObject={[{title:"Youtube",value:"youtube"},{title:"Vimeo",value:"vimeo"},
                    {title:"Mp4URL",value:"mp4URL"},{title:"UploadVideo",value:"uploadVideo"},
               
                                                                                    ]} />  </div> </div>
               {cards[itemNo-1]?.video?.sourceType=="youtube"?
               <>
               <div  style={{margin:"0px",padding:"0px",
               display:"flex",justifyContent:"left",}}>
                <Youtube size={30} style={{marginTop:"15px"}} color={"#999999"} />
 <div  className="ikcraft_login-input-card"style={{margin:"0px",padding:"0px",width:"300px"  }}>
<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  
     style= {{fontSize:"14px",padding:"10px",width:"280px"}} placeholder={`Add Youtube Link `} type="text"
  rows={1} name="courseTitle" value={cards[itemNo-1]?.video?.youtube?.src}
   onChange={(e)=>{updateYoutubeLink(cardObject?.id, e.target.value);}} /></div>
 </div><div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}><h5 style={{}}>Show Default Youtube Thumbnail?  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={cards[itemNo-1]?.video?.youtube?.showDefaultThumbnail} toggleState={(state)=>{ 
                                     updateShowDefaultThumbnailYoutube(cardObject?.id, state);}} /></div>
                                       </div>
          <div  style={{display:"flex",justifyContent:"space-between",marginTop:"-25px"}}><h5 style={{}}>Use Default Youtube Player?  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={cards[itemNo-1]?.video?.youtube?.useDefaultPlayer} toggleState={(state)=>{ 
                                     updateUseDefaultPlayerYoutube(cardObject?.id, state);}} /></div>
                                       </div></>:""}    

   {cards[itemNo-1]?.video?.sourceType=="vimeo"?
               <>
               <div  style={{margin:"0px",padding:"0px",
               display:"flex",justifyContent:"left",}}>
                <SwitchCamera size={30} style={{marginTop:"15px"}} color={"#999999"} />
 <div  className="ikcraft_login-input-card"style={{margin:"0px",padding:"0px",width:"300px"  }}>
<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  
     style= {{fontSize:"14px",padding:"10px",width:"280px"}} placeholder={`Add Vimeo Link `} type="text"
  rows={1} name="courseTitle" value={cards[itemNo-1]?.video?.vimeo?.src}
   onChange={(e)=>{updateVimeoLink(cardObject?.id, e.target.value);}} /></div>
  
 </div> <div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}><h5 style={{}}>Show Default Vimeo Thumbnail?  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={cards[itemNo-1]?.video?.vimeo?.showDefaultThumbnail} toggleState={(state)=>{ 
                                     updateShowDefaultThumbnailVimeo(cardObject?.id, state);}} /></div>
                                       </div>
 <div  style={{display:"flex",justifyContent:"space-between",marginTop:"-15px"}}><h5 style={{}}>Use Default Vimeo Player?  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={cards[itemNo-1]?.video?.vimeo?.useDefaultPlayer} toggleState={(state)=>{ 
                                     updateUseDefaultPlayerVimeo(cardObject?.id, state);}} /></div>
                                       </div></>:""}                                                                    
      {cards[itemNo-1]?.video?.sourceType=="mp4URL"?
               
               <div  style={{margin:"0px",padding:"0px",
               display:"flex",justifyContent:"left",}}>
                <Video size={30} style={{marginTop:"15px"}} color={"#999999"} />
 <div  className="ikcraft_login-input-card"style={{margin:"0px",padding:"0px",width:"300px"  }}>
<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  
     style= {{fontSize:"14px",padding:"10px",width:"280px"}} placeholder={`Add Mp4 Link `} type="text"
  rows={1} name="courseTitle" value={cards[itemNo-1]?.video?.mp4URL?.src}
   onChange={(e)=>{updateMp4URL(cardObject?.id, e.target.value);}} /></div>
 </div>:""}                                                                    
     <div  style={{display:"flex",justifyContent:"space-between",marginTop:"5px",background:"rgba(144, 202, 249,0.31) ",borderRadius:"20px",paddingLeft:"10px",paddingRight:"10px"}}>
          {!cards[itemNo-1]?.video?.videoThumbnail?.hideThumbnail?                          
   cards[itemNo-1]?.video?.sourceType=="mp4URL"? <ImageWithFallback src={cards[itemNo-1]?.video?.videoThumbnail?.src} widthOuter={"70px"} fireOpenEdit ={()=>{}}  iconSize={44}  setOpenFullImg={()=>{setOpenFullImg(true)}}/>
   :cards[itemNo-1]?.video?.sourceType=="youtube"? <ImageWithFallback src={cards[itemNo-1]?.video?.youtube?.showDefaultThumbnail?getYouTubeThumbnail(cards[itemNo-1]?.video?.youtube?.src)?.highQuality:cards[itemNo-1]?.video?.videoThumbnail?.src} widthOuter={"70px"} fireOpenEdit ={()=>{}}  iconSize={44}  setOpenFullImg={()=>{setOpenFullImg(true)}}/>
   :cards[itemNo-1]?.video?.sourceType=="vimeo"? <ImageWithFallback src={cards[itemNo-1]?.video?.vimeo?.showDefaultThumbnail?getVimeoThumbnail(cards[itemNo-1]?.video?.vimeo?.src)?.large:cards[itemNo-1]?.video?.videoThumbnail?.src} widthOuter={"70px"} fireOpenEdit ={()=>{}}  iconSize={44}  setOpenFullImg={()=>{setOpenFullImg(true)}}/>:"":""}
        
          <h5 style={{marginTop:"29px"}}>Hide Thumbnail ?  </h5> <div style={{marginTop:"25px"}} >
          <ToggleSmallUI state={cards[itemNo-1]?.video?.videoThumbnail?.hideThumbnail} toggleState={(state)=>{ 
                                     updateHideVideoThumbnail(cardObject?.id, state);}} /></div>
                                        
         </div>


   <div style={{background:"#ffffff",borderRadius:"15px",marginLeft:"3px",marginRight:"3px",marginTop:"5px",padding:"10px",}}>
          <div style={{display:"flex",justifyContent:"space-between",position:"relative"}}><h4>Button Click Action </h4>
            {/* 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) */}
            <DropDownButtonUI activeCard={""} icon={6} title={cards[itemNo-1]?.video?.videoPlayButton?.onClickAction} 
                 onClickSendObject={(value)=>{  
                                    if(value){  updateOnClickAction(cardObject?.id, value);}}}
                  hasDropDown={true} dropDownObject={cards[itemNo-1]?.video?.videoPlayButton?.onClickActionArray} />  </div> </div>


   {/* {cards[itemNo-1]?.video?.videoPlayButton?.onClickAction=="popUpVideo"?<><div style={{background:"rgba(144, 202, 249,0.31) ",borderRadius:"20px",paddingLeft:"10px",paddingRight:"10px"}}>
   <div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}><h5 style={{}}> Only Show Play Button In Card  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={cards[itemNo-1]?.video?.videoPlayButton?.popUpVideo?.showOnlyPlayButton} toggleState={(state)=>{ 
                                     updateShowOnlyPlayButton(cardObject?.id, state);}} /></div>
                                       </div></div>
   </>:""} */}
   {cards[itemNo-1]?.video?.videoPlayButton?.onClickAction=="popUpLeadForm"?<>
   <div style={{background:"rgba(144, 202, 249,0.31) ",borderRadius:"20px",paddingLeft:"10px",paddingRight:"10px"}}>
   <div style={{display:"flex",justifyContent:"space-between",position:"relative",paddingLeft:"0px",paddingRight:"20px"}}>
                                                <h4>Lead Form Pop Up Delay (sec) </h4>      <div style={{margin: '5px' ,paddingLeft:"0px",width:"90px", display:"grid", gridTemplateColumns: "50% 30% 0%" ,alignItems:"center"  }}>
 <Minus  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>{updateLeadFormDelay(cardObject?.id,parseInt(cards[itemNo-1]?.video?.videoPlayButton?.popUpLeadForm?.delay)>1?parseInt(cards[itemNo-1]?.video?.videoPlayButton?.popUpLeadForm?.delay)-2:10)

     }} style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginLeft:"0px",background:"#fff",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}} color="rgba(144, 202, 249,1)" size={13}/>
    <input onMouseEnter={handleMouseEnter} disabled
     onMouseLeave={handleMouseLeave}  value={parseInt(cards[itemNo-1]?.video?.videoPlayButton?.popUpLeadForm?.delay)} type="number"
          onChange={(e)=>{updateLeadFormDelay(cardObject?.id,parseInt(e.target.value))
         }}
          style={{border:"0px dashed #555555  ",borderRadius:"10px",outline:0,width:"50px",
            padding:"0px",marginLeft:"5px",fontSize:"20px",color:"#555555 ",fontWeight:"bolder",marginTop:"0px",}}
      />  <Plus onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  onClick={()=>{
        updateLeadFormDelay(cardObject?.id,parseInt(cards[itemNo-1]?.video?.videoPlayButton?.popUpLeadForm?.delay)<100?parseInt(cards[itemNo-1]?.video?.videoPlayButton?.popUpLeadForm?.delay)+2:10)
     
      }}  style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginRight:"0px",background:"#fff",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}}  color="rgba(144, 202, 249,1)" size={13}/>
        
        
        
        </div> </div>
         <div style={{display:"flex",justifyContent:"space-between",position:"relative",paddingLeft:"0px",paddingRight:"20px"}}>
                                                <h4>Send Lead Info To Your Email </h4> </div>
        <div  style={{margin:"0px",padding:"0px",
               display:"flex",justifyContent:"left",}}>
                <MailCheck size={30} style={{marginTop:"15px"}} color={"#999999"} />
 <div  className="ikcraft_login-input-card"style={{margin:"0px",padding:"0px",width:"300px"  }}>
<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  
     style= {{fontSize:"14px",padding:"10px",width:"280px"}} placeholder={`Add Email Id `} type="text"
  rows={1} name="courseTitle" value={cards[itemNo-1]?.video?.videoPlayButton?.popUpLeadForm?.sendLeadInfoToEmail?.email}
   onChange={(e)=>{updateSendLeadInfoEmailID(cardObject?.id, e.target.value);}} /></div>
 </div>
  <div style={{display:"flex",justifyContent:"space-between",position:"relative",paddingLeft:"0px",paddingRight:"20px"}}>
                                                <h4>Set Which Fields You Want To Show In Lead Form? </h4> </div>
 <div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}><h5 style={{}}>Show Name Input Field  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={cards[itemNo-1]?.video?.videoPlayButton?.popUpLeadForm?.showFields?.name} toggleState={(state)=>{ 
                                     updateShowNameInLeadForm(cardObject?.id, state);}} /></div>
                                       </div><div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}><h5 style={{}}>Show Email Input Field  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={cards[itemNo-1]?.video?.videoPlayButton?.popUpLeadForm?.showFields?.email} toggleState={(state)=>{ 
                                     updateShowEmailInLeadForm(cardObject?.id, state);}} /></div>
                                       </div><div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}><h5 style={{}}>Show Mobile Number  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={cards[itemNo-1]?.video?.videoPlayButton?.popUpLeadForm?.showFields?.mobile} toggleState={(state)=>{ 
                                     updateShowMobileNoInLeadForm(cardObject?.id, state);}} /></div>
                                       </div>
                                       <div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}><h5 style={{}}>Show City Input Field  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={cards[itemNo-1]?.video?.videoPlayButton?.popUpLeadForm?.showFields?.city} toggleState={(state)=>{ 
                                     updateShowCityInLeadForm(cardObject?.id, state);}} /></div>
                                       </div>
 
 </div>
        
        </>:""}

                               <div style={{display:"flex",justifyContent:"space-between",position:"relative",marginTop:"10px"}}>
                                <h4>Play Button Color  </h4>
                                <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                 <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}style={{height:"20px",marginTop:"10px"}}>
                                             <div style={{display:"flex",justifyContent:"space-between",fontSize:"16px"}} >
                                              
                                           Normal
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={playBtnColorSetType=="normal"?"yes":""}
                   className="input-textbox"  value={"normal"}  name={"playBtnColorSetType"}   
                   onClick={e=>{setPlayBtnColorSetType("normal");setPalletPlayBtnBG(true);setPalletPlayBtnBGGradient(false);}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{height:"20px",marginTop:"10px"}}>
                                             <div style={{display:"flex",justifyContent:"space-between",fontSize:"16px"}} >
                                              
                                           Hover
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={playBtnColorSetType=="hover"?"yes":""}
                   className="input-textbox"  value={"hover"}  name={"playBtnColorSetType"}   
                   onClick={e=>{setPlayBtnColorSetType("hover");setPalletPlayBtnBGHover(true);setPalletPlayBtnBGHoverGradient(false);}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                          {playBtnColorSetType!==""? <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{height:"20px",marginTop:"10px"}}>
                                             <div style={{display:"flex",justifyContent:"space-between",fontSize:"16px"}} >
                                              
                                          <X size={25}  color={"#333333"}/>
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={playBtnColorSetType==""?"yes":""}
                   className="input-textbox"  value={""}  name={"playBtnColorSetType"}   
                   onClick={e=>{setPlayBtnColorSetType("")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>:""}
                       {playBtnColorSetType=="normal"?<><div style={{marginTop:"15px"}} > 
                                                        {palletPlayBtnBGGradient?<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:cards[itemNo-1]?.video?.videoPlayButton?.playButtonColor?.normal?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletPlayBtnBG1"  
                                                       onChange={e=>{setPalletPlayBtnBG(true);setPalletPlayBtnBGGradient(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>
                                                             :<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:cards[itemNo-1]?.video?.videoPlayButton?.playButtonColor?.normal?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletPlayBtnBGGradient1"  
                                                       onChange={e=>{setPalletPlayBtnBGGradient(true);setPalletPlayBtnBG(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>}
                                                            </div></>:""}  


     {playBtnColorSetType=="hover"?<><div style={{marginTop:"15px"}} > 
        {palletPlayBtnBGHoverGradient?<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:cards[itemNo-1]?.video?.videoPlayButton?.playButtonColor?.hover?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletPlayBtnBGHover1"  
                                                       onChange={e=>{setPalletPlayBtnBGHover(true);setPalletPlayBtnBGHoverGradient(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>
                                                             :<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:cards[itemNo-1]?.video?.videoPlayButton?.playButtonColor?.hover?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletPlayBtnBGHoverGradient1"  
                                                       onChange={e=>{setPalletPlayBtnBGHoverGradient(true);setPalletPlayBtnBGHover(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>}
                                                            </div></>:""}  
                        </div> 
                            </div> 
   {playBtnColorSetType=="normal"?<> 
                {palletPlayBtnBGGradient?<>
                      <div style={{position:"relative",right:"5px",zIndex:"9999999"}}><ColorPickerGradientDynamic activeColorPickerValue={cards[itemNo-1]?.video?.videoPlayButton?.playButtonColor?.normal?.color} setActiveColorPickerValue={(color)=>{
                      updatePlayButtonBGNormal(cardObject?.id, color);
                   
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Play Button BG"}/> 
                     </div></>:<>
                      <div style={{position:"relative",right:"0px",zIndex:"9999999"}}><ColorPickerDynamicTwo activeColorPickerValue={cards[itemNo-1]?.video?.videoPlayButton?.playButtonColor?.normal?.color} setActiveColorPickerValue={(color)=>{
                    updatePlayButtonBGNormal(cardObject?.id, color);
                     
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Play Button BG"}/> 
                     </div></> } 

</>:""}

  {playBtnColorSetType=="hover"?<> 
                {palletPlayBtnBGHoverGradient?<>
                      <div style={{position:"relative",right:"5px",zIndex:"9999999"}}><ColorPickerGradientDynamic activeColorPickerValue={cards[itemNo-1]?.video?.videoPlayButton?.playButtonColor?.hover?.color} setActiveColorPickerValue={(color)=>{
                      updatePlayButtonBGHover(cardObject?.id, color);
                   
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Play Button BG"}/> 
                     </div></>:<>
                      <div style={{position:"relative",right:"0px",zIndex:"9999999"}}><ColorPickerDynamicTwo activeColorPickerValue={cards[itemNo-1]?.video?.videoPlayButton?.playButtonColor?.hover?.color} setActiveColorPickerValue={(color)=>{
                    updatePlayButtonBGHover(cardObject?.id, color);
                     
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Play Button BG"}/> 
                     </div></> } 

</>:""}


{/* <div style={{display:"flex",justifyContent:"space-between",position:"relative",marginTop:"10px"}}>
                                <h4>Play Icon Color  </h4>
                                <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                 <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}style={{height:"20px",marginTop:"10px"}}>
                                             <div style={{display:"flex",justifyContent:"space-between",fontSize:"16px"}} >
                                              
                                           Normal
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={playIconColorSetType=="normal"?"yes":""}
                   className="input-textbox"  value={"normal"}  name={"playIconColorSetType"}   
                   onClick={e=>{setPlayIconColorSetType("normal");setPalletPlayIconBG(true);setPalletPlayIconBGGradient(false);}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{height:"20px",marginTop:"10px"}}>
                                             <div style={{display:"flex",justifyContent:"space-between",fontSize:"16px"}} >
                                              
                                           Hover
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={playIconColorSetType=="hover"?"yes":""}
                   className="input-textbox"  value={"hover"}  name={"playIconColorSetType"}   
                   onClick={e=>{setPlayIconColorSetType("hover");setPalletPlayIconBGHover(true);setPalletPlayIconBGHoverGradient(false);}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                          {playIconColorSetType!==""? <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{height:"20px",marginTop:"10px"}}>
                                             <div style={{display:"flex",justifyContent:"space-between",fontSize:"16px"}} >
                                              
                                          <X size={25}  color={"#333333"}/>
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={playIconColorSetType==""?"yes":""}
                   className="input-textbox"  value={""}  name={"playIconColorSetType"}   
                   onClick={e=>{setPlayIconColorSetType("")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>:""}
                         
                        </div> {playIconColorSetType=="normal"?<><div style={{marginTop:"15px"}} > 
                                                        {palletPlayIconBGGradient?<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:cards[itemNo-1]?.video?.videoPlayButton?.playIconColor?.normal?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletPlayIconBG1"  
                                                       onChange={e=>{setPalletPlayIconBG(true);setPalletPlayIconBGGradient(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>
                                                             :<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:cards[itemNo-1]?.video?.videoPlayButton?.playIconColor?.normal?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletPlayIconBGGradient1"  
                                                       onChange={e=>{setPalletPlayIconBGGradient(true);setPalletPlayIconBG(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>}
                                                            </div></>:""}

                                                            {playIconColorSetType=="hover"?<><div style={{marginTop:"15px"}} > 
                                                        {palletPlayIconBGHoverGradient?<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:cards[itemNo-1]?.video?.videoPlayButton?.playIconColor?.hover?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletPlayIconBGHover1"  
                                                       onChange={e=>{setPalletPlayIconBGHover(true);setPalletPlayIconBGHoverGradient(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>
                                                             :<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:cards[itemNo-1]?.video?.videoPlayButton?.playIconColor?.hover?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletPlayIconBGHoverGradient1"  
                                                       onChange={e=>{setPalletPlayIconBGHoverGradient(true);setPalletPlayIconBGHover(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>}
                                                            </div></>:""}
                            </div> */}
                {/* {playIconColorSetType=="normal"?<> 
                {palletPlayIconBGGradient?<>
                      <div style={{position:"relative",right:"5px",zIndex:"9999999"}}><ColorPickerGradientDynamic activeColorPickerValue={cards[itemNo-1]?.video?.videoPlayButton?.playIconColor?.normal?.color} setActiveColorPickerValue={(color)=>{
                      updatePlayIconBGNormal(cardObject?.id, color);
                   
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Play Icon BG"}/> 
                     </div></>:<>
                      <div style={{position:"relative",right:"0px",zIndex:"9999999"}}><ColorPickerDynamicTwo activeColorPickerValue={cards[itemNo-1]?.video?.videoPlayButton?.playIconColor?.normal?.color} setActiveColorPickerValue={(color)=>{
                    updatePlayIconBGNormal(cardObject?.id, color);
                     
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Play Icon BG"}/> 
                     </div></> } </>:""}

 {playIconColorSetType=="hover"?<> 
                {palletPlayIconBGHoverGradient?<>
                      <div style={{position:"relative",right:"5px",zIndex:"9999999"}}><ColorPickerGradientDynamic activeColorPickerValue={cards[itemNo-1]?.video?.videoPlayButton?.playIconColor?.hover?.color} setActiveColorPickerValue={(color)=>{
                      updatePlayIconBGHover(cardObject?.id, color);
                   
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Play Icon BG"}/> 
                     </div></>:<>
                      <div style={{position:"relative",right:"0px",zIndex:"9999999"}}><ColorPickerDynamicTwo activeColorPickerValue={cards[itemNo-1]?.video?.videoPlayButton?.playIconColor?.hover?.color} setActiveColorPickerValue={(color)=>{
                    updatePlayIconBGHover(cardObject?.id, color);
                     
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Play Icon BG"}/> 
                     </div></> } </>:""} */}

<div style={{background:"#ffffff",borderRadius:"15px",marginTop:"10px",padding:"10px",}}>
       
               
             <div className="" style={{background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginBottom:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
        
                      
            
                        <div style={{display:"flex",justifyContent:"space-around"}}><h4> Play Button Radius </h4>
                        <div style={{display:"flex",justifyContent:"space-around"}}>
            <RangeSliderBorderRadius resolution={resolution}  setSliderVal={(val)=>{ 
              updatePlayButtonBorderRadius(cardObject?.id, {value:val,resolution:resolution});
              }} 
               sliderVal={cards[itemNo-1]?.video?.videoPlayButton?.playButtonBorderRadius?.value} />
              <div style={{height:"50px" ,width:"90px"}}> 
            <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                  
                         
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} >
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                          %
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={resolution=="%"?"yes":""}
                   className="input-textbox"  value="%"  name={"playButtonBorderRadiuspx"}  
                   onChange={e=>{setPxPercent("%")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            px                        
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={resolution=="px"?"yes":""}
                   className="input-textbox"  value="px"  name={"playButtonBorderRadiuspx"}   
                   onChange={e=>{setPxPercent("px")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                        </div>  </div></div></div>
               </div> 
               <div style={{height:"60px"}}> 
            <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                               <h4>{"Corner Type  "} </h4>   <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                           <Square color={"#333"} size={30}/>
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={cornerType=="square"?"yes":""}
                   className="input-textbox"  value={"square"}  name={"playButtonBorderRadius"}   
                   onClick={e=>{setCornerType("square");
                     updatePlayButtonBorderRadius(cardObject?.id, {value:0,resolution:"px"});
                     
                   ;setPxPercent("px")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                            <Squircle color={"#333"} size={30}/>                       
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={cornerType=="squircle"?"yes":""}
                   className="input-textbox"  value="squircle"  name={"playButtonBorderRadius"}  
                   onChange={e=>{setCornerType("squircle");
                    updatePlayButtonBorderRadius(cardObject?.id, {value:20,resolution:"px"});

                   setPxPercent("px")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                               <Circle color={"#333"} size={30}/>
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={cornerType=="circle"?"yes":""}
                   className="input-textbox"  value="circle"  name={"playButtonBorderRadius"} 
                   onChange={e=>{setCornerType("circle");
                     updatePlayButtonBorderRadius(cardObject?.id, {value:50,resolution:"%"});
                    
                   setPxPercent("px")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                         
                        </div>  </div></div> 

                                                    </div></div>




         </div></div>:""}

         {settingType=="editButton"?<>
          <div style={{  display: "flex", gap: "5px",justifyContent:"left"}}>
             
        {/* <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:99999,cursor:"pointer",}} onClick={()=>{setEditImage(false);setCardObject({})}} className="appDesignPopUpOpacity"> </div> */}
        <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{position:"relative",cursor:"pointer",background:"#fff",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.1501)",
     width:"40px",height:"40px",left:"0px",top:"2px",margin:"5px",display:"flex",justifyContent:"center",alignItems:"center"}}
      onClick={()=>{setSettingType("editCard");setStartButtonEdit(false) ;}} >
                <MoveLeft size={20} color={"#555"}  />
             </div><div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{position:"relative",cursor:"pointer",background:"#fff",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.1501)",
     width:"40px",height:"40px",left:"0px",top:"2px",margin:"5px",display:"flex",justifyContent:"center",alignItems:"center"}}
      onClick={()=>{setStartButtonEdit(true) ;}} >
                <FolderKanban size={20} color={"#555"}  />
             </div>

        <h2 align="center" style={{marginTop:"13px"}} > Edit Button In <span className="coloredTextV1" >Card  {itemNo}</span> </h2>
      </div> 
          {startButtonEdit?<div style={{display: "flex",
flexWrap: "wrap"}}>
       
          <div     onClick={()=>{ setStartButtonEdit(false) ;setButtonNumber("button1")}}  style={{width:"130px",borderRadius:"10px",margin:"10px",fontSize:"14px",padding:"7px 15px"
            ,background:"#f1f1f1"}}>{cards[itemNo-1]?.button1?.buttonText}</div>
           <div  onClick={()=>{ setStartButtonEdit(false) ;setButtonNumber("button2")}}  style={{width:"130px",borderRadius:"10px",margin:"10px",fontSize:"14px",padding:"7px 15px"
            ,background:"#f1f1f1"}}>{cards[itemNo-1]?.button2?.buttonText}</div>
           <div  onClick={()=>{ setStartButtonEdit(false) ;setButtonNumber("button3")}} style={{width:"130px",borderRadius:"10px",margin:"10px",fontSize:"14px",padding:"7px 15px"
            ,background:"#f1f1f1"}}>{cards[itemNo-1]?.button3?.buttonText}</div>
           <div  onClick={()=>{ setStartButtonEdit(false) ;setButtonNumber("button4")}} style={{width:"130px",borderRadius:"10px",margin:"10px",fontSize:"14px",padding:"7px 15px"
            ,background:"#f1f1f1"}}>{cards[itemNo-1]?.button4?.buttonText}</div>
           <div  onClick={()=>{ setStartButtonEdit(false) ;setButtonNumber("button5")}} style={{width:"130px",borderRadius:"10px",margin:"10px",fontSize:"14px",padding:"7px 15px"
            ,background:"#f1f1f1"}}>{cards[itemNo-1]?.button5?.buttonText}</div>
           
          
          </div>:""}
           {/* <ContentCardUIButtonSettings 
         callbackItemValue={(id,val,type)=>{
          setButtonUpdate(cardObject?.id,id,val,type);
           }} buttonItem={buttonObject} /> */}

{!startButtonEdit?<>  <h4>Editing Button {buttonNumber=="button1"?1:buttonNumber=="button1"?1:buttonNumber=="button2"?2:buttonNumber=="button3"?3:buttonNumber=="button4"?4:buttonNumber=="button5"?5:""} </h4>
<div style={{background:"#ffffff",borderRadius:"15px",marginLeft:"3px",marginRight:"3px",marginTop:"5px",padding:"10px",}}>
          <div style={{display:"flex",justifyContent:"space-between",position:"relative"}}><h4>Button Theme </h4>
            {/* 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) */}
            <DropDownButtonUI activeCard={""} icon={6} title={buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonTheme:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonTheme:buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonTheme:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonTheme:buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonTheme:""} 
                 onClickSendObject={(value)=>{  
                                    if(value){    setButtonUpdate(cardObject?.id,value,buttonNumber=="button1"?"button1Theme":buttonNumber=="button2"?"button2Theme":buttonNumber=="button3"?"button3Theme":buttonNumber=="button4"?"button4Theme":buttonNumber=="button5"?"button5Theme":"");}}}
                  hasDropDown={true} dropDownObject={buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonThemeArray:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonThemeArray:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonThemeArray:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonThemeArray:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonThemeArray:[]
                  } />  </div> </div>
<div  className="ikcraft_login-input-card"style={{margin:"0px",padding:"0px"}}>
   
<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"18px",padding:"10px"}} placeholder={`Add Button Title`} type="text"
  rows={1} name="courseTitle" value={buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonText:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonText:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonText:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonText:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonText:cards[itemNo-1]?.button1?.buttonText} onChange={(e)=>{
    
     setButtonUpdate(cardObject?.id,e.target.value,buttonNumber=="button1"?"button1Text":buttonNumber=="button2"?"button2Text":buttonNumber=="button3"?"button3Text":buttonNumber=="button4"?"button4Text":buttonNumber=="button5"?"button5Text":"");
 
  }} /> </div>
  <div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}><h5 style={{}}>Show Text In Button?  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={buttonNumber=="button1"?cards[itemNo-1]?.button1?.showText:buttonNumber=="button2"?cards[itemNo-1]?.button2?.showText:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.showText:buttonNumber=="button4"?cards[itemNo-1]?.button4?.showText:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.showText:cards[itemNo-1]?.button1?.showText} toggleState={(state)=>{ 
                                   setButtonUpdate(cardObject?.id,state,buttonNumber=="button1"?"button1ShowText":buttonNumber=="button2"?"button2ShowText":buttonNumber=="button3"?"button3ShowText":buttonNumber=="button4"?"button4ShowText":buttonNumber=="button5"?"button5ShowText":"");}} /></div>
                                       </div>

                                       <div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}><h5 style={{}}>Show Icon In Button?  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={buttonNumber=="button1"?cards[itemNo-1]?.button1?.showIcon:buttonNumber=="button2"?cards[itemNo-1]?.button2?.showIcon:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.showIcon:buttonNumber=="button4"?cards[itemNo-1]?.button4?.showIcon:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.showIcon:cards[itemNo-1]?.button1?.showIcon} toggleState={(state)=>{ 
                                   setButtonUpdate(cardObject?.id,state,buttonNumber=="button1"?"button1ShowIcon":buttonNumber=="button2"?"button2ShowIcon":buttonNumber=="button3"?"button3ShowIcon":buttonNumber=="button4"?"button4ShowIcon":buttonNumber=="button5"?"button5ShowIcon":"");}} /></div>
                                       </div>







<div style={{display:"flex",justifyContent:"space-between",position:"relative",marginTop:"10px"}}>
                                <h4>Button BG Color  </h4>
                                <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                 <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}style={{height:"20px",marginTop:"10px"}}>
                                             <div style={{display:"flex",justifyContent:"space-between",fontSize:"16px"}} >
                                              
                                           Normal
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={buttonBGColorSetType=="normal"?"yes":""}
                   className="input-textbox"  value={"normal"}  name={"buttonBGColorSetType"}   
                   onClick={e=>{setButtonBGColorSetType("normal");setPalletButtonBGColor(true);setPalletButtonBGColorGradient(false);}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{height:"20px",marginTop:"10px"}}>
                                             <div style={{display:"flex",justifyContent:"space-between",fontSize:"16px"}} >
                                              
                                           Hover
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={buttonBGColorSetType=="hover"?"yes":""}
                   className="input-textbox"  value={"hover"}  name={"buttonBGColorSetType"}   
                   onClick={e=>{setButtonBGColorSetType("hover");setPalletButtonBGColorHover(true);setPalletButtonBGColorHoverGradient(false);}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                          {buttonBGColorSetType!==""? <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{height:"20px",marginTop:"10px"}}>
                                             <div style={{display:"flex",justifyContent:"space-between",fontSize:"16px"}} >
                                              
                                          <X size={25}  color={"#333333"}/>
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={buttonBGColorSetType==""?"yes":""}
                   className="input-textbox"  value={""}  name={"buttonBGColorSetType"}   
                   onClick={e=>{setButtonBGColorSetType("")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>:""}
                         
                        </div> {buttonBGColorSetType=="normal"?<><div style={{marginTop:"15px"}} > 
                                                        {palletButtonBGColorGradient?<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonBGColor?.normal?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonBGColor?.normal?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonBGColor?.normal?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonBGColor?.normal?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonBGColor?.normal?.color:cards[itemNo-1]?.button1?.buttonBGColor?.normal?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletPlayIconBG1"  
                                                       onChange={e=>{setPalletButtonBGColor(true);setPalletButtonBGColorGradient(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>
                                                             :<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonBGColor?.normal?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonBGColor?.normal?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonBGColor?.normal?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonBGColor?.normal?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonBGColor?.normal?.color:cards[itemNo-1]?.button1?.buttonBGColor?.normal?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletPlayIconBGGradient1"  
                                                       onChange={e=>{setPalletButtonBGColorGradient(true);setPalletButtonBGColor(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>}
                                                            </div></>:""}

                                                            {buttonBGColorSetType=="hover"?<><div style={{marginTop:"15px"}} > 
                                                        {palletButtonBGColorHoverGradient?<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonBGColor?.hover?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonBGColor?.hover?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonBGColor?.hover?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonBGColor?.hover?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonBGColor?.hover?.color:cards[itemNo-1]?.button1?.buttonBGColor?.hover?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletPlayIconBGHover1"  
                                                       onChange={e=>{setPalletButtonBGColorHover(true);setPalletButtonBGColorHoverGradient(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>
                                                             :<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonBGColor?.hover?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonBGColor?.hover?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonBGColor?.hover?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonBGColor?.hover?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonBGColor?.hover?.color:cards[itemNo-1]?.button1?.buttonBGColor?.hover?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletPlayIconBGHoverGradient1"  
                                                       onChange={e=>{setPalletButtonBGColorHoverGradient(true);setPalletButtonBGColorHover(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>}
                                                            </div></>:""}
                            </div>
                {buttonBGColorSetType=="normal"?<> 
                {palletButtonBGColorGradient?<>
                      <div style={{position:"relative",right:"5px",zIndex:"9999999"}}><ColorPickerGradientDynamic
                       activeColorPickerValue={buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonBGColor?.normal?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonBGColor?.normal?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonBGColor?.normal?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonBGColor?.normal?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonBGColor?.normal?.color:cards[itemNo-1]?.button1?.buttonBGColor?.normal?.color} setActiveColorPickerValue={(color)=>{
                      setButtonUpdate(cardObject?.id,color,buttonNumber=="button1"?"button1ButtonBGColorNormal":buttonNumber=="button2"?"button2ButtonBGColorNormal":buttonNumber=="button3"?"button3ButtonBGColorNormal":buttonNumber=="button4"?"button4ButtonBGColorNormal":buttonNumber=="button5"?"button5ButtonBGColorNormal":"");
                   
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Button BG Color"}/> 
                     </div></>:<>
                      <div style={{position:"relative",right:"0px",zIndex:"9999999"}}><ColorPickerDynamicTwo 
                      activeColorPickerValue={buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonBGColor?.normal?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonBGColor?.normal?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonBGColor?.normal?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonBGColor?.normal?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonBGColor?.normal?.color:cards[itemNo-1]?.button1?.buttonBGColor?.normal?.color} setActiveColorPickerValue={(color)=>{
                     setButtonUpdate(cardObject?.id,color,buttonNumber=="button1"?"button1ButtonBGColorNormal":buttonNumber=="button2"?"button2ButtonBGColorNormal":buttonNumber=="button3"?"button3ButtonBGColorNormal":buttonNumber=="button4"?"button4ButtonBGColorNormal":buttonNumber=="button5"?"button5ButtonBGColorNormal":"");
                    
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Button BG Color"}/> 
                     </div></> } </>:""}

 {buttonBGColorSetType=="hover"?<> 
                {palletButtonBGColorHoverGradient?<>
                      <div style={{position:"relative",right:"5px",zIndex:"9999999"}}><ColorPickerGradientDynamic
                       activeColorPickerValue={buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonBGColor?.hover?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonBGColor?.hover?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonBGColor?.hover?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonBGColor?.hover?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonBGColor?.hover?.color:cards[itemNo-1]?.button1?.buttonBGColor?.hover?.color} setActiveColorPickerValue={(color)=>{
                     setButtonUpdate(cardObject?.id,color,buttonNumber=="button1"?"button1ButtonBGColorHover":buttonNumber=="button2"?"button2ButtonBGColorHover":buttonNumber=="button3"?"button3ButtonBGColorHover":buttonNumber=="button4"?"button4ButtonBGColorHover":buttonNumber=="button5"?"button5ButtonBGColorHover":"");
                   
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Button BG Color"}/> 
                     </div></>:<>
                      <div style={{position:"relative",right:"0px",zIndex:"9999999"}}><ColorPickerDynamicTwo
                       activeColorPickerValue={buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonBGColor?.hover?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonBGColor?.hover?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonBGColor?.hover?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonBGColor?.hover?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonBGColor?.hover?.color:cards[itemNo-1]?.button1?.buttonBGColor?.hover?.color} setActiveColorPickerValue={(color)=>{
                     setButtonUpdate(cardObject?.id,color,buttonNumber=="button1"?"button1ButtonBGColorHover":buttonNumber=="button2"?"button2ButtonBGColorHover":buttonNumber=="button3"?"button3ButtonBGColorHover":buttonNumber=="button4"?"button4ButtonBGColorHover":buttonNumber=="button5"?"button5ButtonBGColorHover":"");
                     
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Button BG Color"}/> 
                     </div></> } </>:""}







<div style={{display:"flex",justifyContent:"space-between",position:"relative",marginTop:"10px"}}>
                                <h4>Text And Icon Color  </h4>
                                <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                 <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}style={{height:"20px",marginTop:"10px"}}>
                                             <div style={{display:"flex",justifyContent:"space-between",fontSize:"16px"}} >
                                              
                                           Normal
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={buttonTextAndIconColorSetType=="normal"?"yes":""}
                   className="input-textbox"  value={"normal"}  name={"buttonTextAndIconColorSetType"}   
                   onClick={e=>{setButtonTextAndIconColorSetType("normal");setPalletButtonTextAndIconColor(true);setPalletButtonTextAndIconColorGradient(false);}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{height:"20px",marginTop:"10px"}}>
                                             <div style={{display:"flex",justifyContent:"space-between",fontSize:"16px"}} >
                                              
                                           Hover
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={buttonTextAndIconColorSetType=="hover"?"yes":""}
                   className="input-textbox"  value={"hover"}  name={"buttonTextAndIconColorSetType"}   
                   onClick={e=>{setButtonTextAndIconColorSetType("hover");setPalletButtonTextAndIconColorHover(true);setPalletButtonTextAndIconColorHoverGradient(false);}}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                          {buttonTextAndIconColorSetType!==""? <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{height:"20px",marginTop:"10px"}}>
                                             <div style={{display:"flex",justifyContent:"space-between",fontSize:"16px"}} >
                                              
                                          <X size={25}  color={"#333333"}/>
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={buttonTextAndIconColorSetType==""?"yes":""}
                   className="input-textbox"  value={""}  name={"buttonTextAndIconColorSetType"}   
                   onClick={e=>{setButtonTextAndIconColorSetType("")}}/>
                        <span class={"boxCardBorder-two"}></span> </label>:""}
                         
                        </div> {buttonTextAndIconColorSetType=="normal"?<><div style={{marginTop:"15px"}} > 
                                                        {palletButtonTextAndIconColorGradient?<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonTextAndIconColor?.normal?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonTextAndIconColor?.normal?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonTextAndIconColor?.normal?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonTextAndIconColor?.normal?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonTextAndIconColor?.normal?.color:cards[itemNo-1]?.button1?.buttonTextAndIconColor?.normal?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletButtonTextAndIconColor1"  
                                                       onChange={e=>{setPalletButtonTextAndIconColor(true);setPalletButtonTextAndIconColorGradient(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>
                                                             :<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonTextAndIconColor?.normal?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonTextAndIconColor?.normal?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonTextAndIconColor?.normal?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonTextAndIconColor?.normal?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonTextAndIconColor?.normal?.color:cards[itemNo-1]?.button1?.buttonTextAndIconColor?.normal?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletButtonTextAndIconColorGradient1"  
                                                       onChange={e=>{setPalletButtonTextAndIconColorGradient(true);setPalletButtonTextAndIconColor(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>}
                                                            </div></>:""}

                                                            {buttonTextAndIconColorSetType=="hover"?<><div style={{marginTop:"15px"}} > 
                                                        {palletButtonTextAndIconColorHoverGradient?<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonTextAndIconColor?.hover?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonTextAndIconColor?.hover?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonTextAndIconColor?.hover?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonTextAndIconColor?.hover?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonTextAndIconColor?.hover?.color:cards[itemNo-1]?.button1?.buttonTextAndIconColor?.hover?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletPlayIconBGHover1"  
                                                       onChange={e=>{setPalletButtonTextAndIconColorHover(true);setPalletButtonTextAndIconColorHoverGradient(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>
                                                             :<label onMouseEnter={
                                                                                 ()=>handleMouseEnter("#fff","#333","")}
                                                                  onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonTextAndIconColor?.hover?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonTextAndIconColor?.hover?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonTextAndIconColor?.hover?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonTextAndIconColor?.hover?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonTextAndIconColor?.hover?.color:cards[itemNo-1]?.button1?.buttonTextAndIconColor?.hover?.color}}>
                                                                                <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                                
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                 <Palette onMouseEnter={handleMouseEnter}
                                                                                                         onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                         
                                                                                 </div> 
                                                                  <input type="checkbox" title="Color Theme"   checked={"yes"}
                                                       className="input-textbox"  value={true}  name="palletButtonTextAndIconColorHoverGradient1"  
                                                       onChange={e=>{setPalletButtonTextAndIconColorHoverGradient(true);setPalletButtonTextAndIconColorHover(false);}}/>
                                                            <span class={"boxCardBorder-two"} style={{}}></span> </label>}
                                                            </div></>:""}
                            </div>
                {buttonTextAndIconColorSetType=="normal"?<> 
                {palletButtonTextAndIconColorGradient?<>
                      <div style={{position:"relative",right:"5px",zIndex:"9999999"}}><ColorPickerGradientDynamic
                       activeColorPickerValue={buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonTextAndIconColor?.normal?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonTextAndIconColor?.normal?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonTextAndIconColor?.normal?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonTextAndIconColor?.normal?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonTextAndIconColor?.normal?.color:cards[itemNo-1]?.button1?.buttonTextAndIconColor?.normal?.color} setActiveColorPickerValue={(color)=>{
                     setButtonUpdate(cardObject?.id,color,buttonNumber=="button1"?"button1ButtonTextAndIconColorNormal":buttonNumber=="button2"?"button2ButtonTextAndIconColorNormal":buttonNumber=="button3"?"button3ButtonTextAndIconColorNormal":buttonNumber=="button4"?"button4ButtonTextAndIconColorNormal":buttonNumber=="button5"?"button5ButtonTextAndIconColorNormal":"");
                    
                     
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Button Text & Icon Color"}/> 
                     </div></>:<>
                      <div style={{position:"relative",right:"0px",zIndex:"9999999"}}><ColorPickerDynamicTwo 
                      activeColorPickerValue={buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonTextAndIconColor?.normal?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonTextAndIconColor?.normal?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonTextAndIconColor?.normal?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonTextAndIconColor?.normal?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonTextAndIconColor?.normal?.color:cards[itemNo-1]?.button1?.buttonTextAndIconColor?.normal?.color} setActiveColorPickerValue={(color)=>{
                     setButtonUpdate(cardObject?.id,color,buttonNumber=="button1"?"button1ButtonTextAndIconColorNormal":buttonNumber=="button2"?"button2ButtonTextAndIconColorNormal":buttonNumber=="button3"?"button3ButtonTextAndIconColorNormal":buttonNumber=="button4"?"button4ButtonTextAndIconColorNormal":buttonNumber=="button5"?"button5ButtonTextAndIconColorNormal":"");
                    
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Button Text & Icon Color"}/> 
                     </div></> } </>:""}

 {buttonTextAndIconColorSetType=="hover"?<> 
                {palletButtonTextAndIconColorHoverGradient?<>
                      <div style={{position:"relative",right:"5px",zIndex:"9999999"}}><ColorPickerGradientDynamic
                       activeColorPickerValue={buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonTextAndIconColor?.hover?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonTextAndIconColor?.hover?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonTextAndIconColor?.hover?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonTextAndIconColor?.hover?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonTextAndIconColor?.hover?.color:cards[itemNo-1]?.button1?.buttonTextAndIconColor?.hover?.color} setActiveColorPickerValue={(color)=>{
                     setButtonUpdate(cardObject?.id,color,buttonNumber=="button1"?"button1ButtonTextAndIconColorHover":buttonNumber=="button2"?"button2ButtonTextAndIconColorHover":buttonNumber=="button3"?"button3ButtonTextAndIconColorHover":buttonNumber=="button4"?"button4ButtonTextAndIconColorHover":buttonNumber=="button5"?"button5ButtonTextAndIconColorHover":"");
                   
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Button Text & Icon Color"}/> 
                     </div></>:<>
                      <div style={{position:"relative",right:"0px",zIndex:"9999999"}}><ColorPickerDynamicTwo
                       activeColorPickerValue={buttonNumber=="button1"?cards[itemNo-1]?.button1?.buttonTextAndIconColor?.hover?.color:buttonNumber=="button2"?cards[itemNo-1]?.button2?.buttonTextAndIconColor?.hover?.color:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.buttonTextAndIconColor?.hover?.color:buttonNumber=="button4"?cards[itemNo-1]?.button4?.buttonTextAndIconColor?.hover?.color:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.buttonTextAndIconColor?.hover?.color:cards[itemNo-1]?.button1?.buttonTextAndIconColor?.hover?.color} setActiveColorPickerValue={(color)=>{
                     setButtonUpdate(cardObject?.id,color,buttonNumber=="button1"?"button1ButtonTextAndIconColorHover":buttonNumber=="button2"?"button2ButtonTextAndIconColorHover":buttonNumber=="button3"?"button3ButtonTextAndIconColorHover":buttonNumber=="button4"?"button4ButtonTextAndIconColorHover":buttonNumber=="button5"?"button5ButtonTextAndIconColorHover":"");
                     
                     // console.log(color)
                     }} colorPickerOptionArray={[]}   palletTitle={"Button Text & Icon Color"}/> 
                     </div></> } </>:""}



<div style={{background:"#ffffff",borderRadius:"15px",marginLeft:"3px",marginRight:"3px",marginTop:"5px",padding:"10px",}}>
          <div style={{display:"flex",justifyContent:"space-between",position:"relative"}}><h4>Button Click Action </h4>
            {/* 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) */}
            <DropDownButtonUI activeCard={""} icon={6} title={buttonNumber=="button1"?cards[itemNo-1]?.button1?.onClickAction:buttonNumber=="button2"?cards[itemNo-1]?.button2?.onClickAction:buttonNumber=="button3"?cards[itemNo-1]?.button3?.onClickAction:buttonNumber=="button4"?cards[itemNo-1]?.button4?.onClickAction:buttonNumber=="button5"?cards[itemNo-1]?.button5?.onClickAction:""} 
                 onClickSendObject={(value)=>{  
                                    if(value){    setButtonUpdate(cardObject?.id,value,buttonNumber=="button1"?"button1ClickAction":buttonNumber=="button2"?"button2ClickAction":buttonNumber=="button3"?"button3ClickAction":buttonNumber=="button4"?"button4ClickAction":buttonNumber=="button5"?"button5ClickAction":"");}}}
                  hasDropDown={true} dropDownObject={buttonNumber=="button1"?cards[itemNo-1]?.button1?.onClickActionArray:buttonNumber=="button2"?cards[itemNo-1]?.button2?.onClickActionArray:
                    buttonNumber=="button3"?cards[itemNo-1]?.button3?.onClickActionArray:buttonNumber=="button4"?cards[itemNo-1]?.button4?.onClickActionArray:
                    buttonNumber=="button5"?cards[itemNo-1]?.button5?.onClickActionArray:[]
                  } />  </div> </div>


 {buttonNumber=="button1"&&cards[itemNo-1]?.button1?.onClickAction=="popUpLeadForm"||buttonNumber=="button2"&&cards[itemNo-1]?.button2?.onClickAction=="popUpLeadForm"||buttonNumber=="button3"&&cards[itemNo-1]?.button3?.onClickAction=="popUpLeadForm"||buttonNumber=="button4"&&cards[itemNo-1]?.button4?.onClickAction=="popUpLeadForm"||buttonNumber=="button5"&&cards[itemNo-1]?.button5?.onClickAction=="popUpLeadForm"?<>
   <div style={{background:"rgba(144, 202, 249,0.31) ",borderRadius:"20px",paddingLeft:"10px",paddingRight:"10px"}}>
  
         <div style={{display:"flex",justifyContent:"space-between",position:"relative",paddingLeft:"0px",paddingRight:"20px"}}>
                                                <h4>Send Lead Info To Your Email </h4> </div>
                                               
        <div  style={{margin:"0px",padding:"0px",
               display:"flex",justifyContent:"left",}}>
                <MailCheck size={30} style={{marginTop:"15px"}} color={"#999999"} />
 <div  className="ikcraft_login-input-card"style={{margin:"0px",padding:"0px",width:"300px"  }}>
<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  
     style= {{fontSize:"14px",padding:"10px",width:"280px"}} placeholder={`Add Email Id `} type="text"
  rows={1} name="courseTitle" value={buttonNumber=="button1"?cards[itemNo-1]?.button1?.popUpLeadForm?.sendLeadInfoToEmail?.email:buttonNumber=="button2"?cards[itemNo-1]?.button2?.popUpLeadForm?.sendLeadInfoToEmail?.email:buttonNumber=="button3"?cards[itemNo-1]?.button3?.popUpLeadForm?.sendLeadInfoToEmail?.email:buttonNumber=="button4"?cards[itemNo-1]?.button4?.popUpLeadForm?.sendLeadInfoToEmail?.email:buttonNumber=="button5"?cards[itemNo-1]?.button5?.popUpLeadForm?.sendLeadInfoToEmail?.email:"l"}
   onChange={(e)=>{
    setButtonUpdate(cardObject?.id,e.target.value ,buttonNumber=="button1"?"button1PopUpLeadFormEmail":buttonNumber=="button2"?"button2PopUpLeadFormEmail":buttonNumber=="button3"?"button3PopUpLeadFormEmail":buttonNumber=="button4"?"button4PopUpLeadFormEmail":buttonNumber=="button5"?"button5PopUpLeadFormEmail":"")
    
    }} /></div>
 </div>
  <div style={{display:"flex",justifyContent:"space-between",position:"relative",paddingLeft:"0px",paddingRight:"20px"}}>
                                                <h4>Set Which Fields You Want To Show In Lead Form? </h4> </div>
 <div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}><h5 style={{}}>Show Name Input Field  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={cards[itemNo-1]?.video?.videoPlayButton?.popUpLeadForm?.showFields?.name} toggleState={(state)=>{ 
                                     updateShowNameInLeadForm(cardObject?.id, state);}} /></div>
                                       </div><div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}><h5 style={{}}>Show Email Input Field  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={cards[itemNo-1]?.video?.videoPlayButton?.popUpLeadForm?.showFields?.email} toggleState={(state)=>{ 
                                     updateShowEmailInLeadForm(cardObject?.id, state);}} /></div>
                                       </div><div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}><h5 style={{}}>Show Mobile Number  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={cards[itemNo-1]?.video?.videoPlayButton?.popUpLeadForm?.showFields?.mobile} toggleState={(state)=>{ 
                                     updateShowMobileNoInLeadForm(cardObject?.id, state);}} /></div>
                                       </div>
                                       <div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}><h5 style={{}}>Show City Input Field  </h5>
                                    <div style={{marginTop:"15px"}} ><ToggleSmallUI state={cards[itemNo-1]?.video?.videoPlayButton?.popUpLeadForm?.showFields?.city} toggleState={(state)=>{ 
                                     updateShowCityInLeadForm(cardObject?.id, state);}} /></div>
                                       </div>
 
 </div>
        
        </>:""}


</> :""}
           
         </>:""}

         
         
    </div>
  );
};

export default ContentCardUISettings;